import { Area as AreaData } from "@saysom/shared"
import { RefObject } from "react"
import { Mesh } from "three"
import { create } from "zustand"
import { immer } from "zustand/middleware/immer"

export interface Area extends AreaData {
	mesh?: RefObject<Mesh>
	image?: File
	iconImage?: File
}

type UpdateArea = {
	add: (areaId: string, area: Area) => void
}

type AreaStore = {
	areas: Record<string, Area>

	updateArea: UpdateArea
}

export const useAreaStore = create(
	immer<AreaStore>((set, get) => ({
		areas: {},

		updateArea: {
			add(areaId, area) {
				const { areas, updateArea } = get()
				set((state) => {
					state.areas[areaId] = area
				})
			},
		},
	}))
)
